// extracted by mini-css-extract-plugin
export var form = "_dj-0";